import api from './api';
import { DailyBalanceDTO, DailyBalanceParams, ReportMovementDTO } from '../types';

/**
 * Servicio para consultar los endpoints analíticos y de reportes
 */
export const reportService = {
    /**
     * Resumen Diario (Alto Nivel)
     * GET /api/reports/daily-balance
     *
     * Agrupa los movimientos por día matemático. Ideal para gráficos y visión gerencial.
     *
     * @param params - cashBoxId, startDate, endDate
     * @returns Lista de balances diarios (fecha, ingresos, egresos, neto)
     */
    getDailyBalance: async (params: DailyBalanceParams): Promise<DailyBalanceDTO[]> => {
        try {
            const response = await api.get<DailyBalanceDTO[]>('/reports/daily-balance', {
                params: {
                    cashBoxId: params.cashBoxId,
                    startDate: params.startDate,
                    endDate: params.endDate,
                },
            });
            return response.data;
        } catch (error) {
            console.error('Error fetching daily balance report:', error);
            throw error;
        }
    },

    /**
     * Movimientos Detallados (Auditoría)
     * GET /api/reports/cashbox-movements
     *
     * Lista plana cronológica (Libro Mayor). Ideal para rastrear entradas puntuales.
     *
     * @param params - cashBoxId, startDate, endDate
     * @returns Lista de movimientos unitarios (motivo, tipo, entrada/salida, monto)
     */
    getCashBoxMovements: async (
        params: { cashBoxId: number; startDate: string; endDate: string }
    ): Promise<ReportMovementDTO[]> => {
        try {
            const response = await api.get<ReportMovementDTO[]>('/reports/cashbox-movements', {
                params: {
                    cashBoxId: params.cashBoxId,
                    startDate: params.startDate,
                    endDate: params.endDate,
                },
            });
            return response.data;
        } catch (error) {
            console.error('Error fetching cashbox movements report:', error);
            throw error;
        }
    },
};

export default reportService;
